/* GENERATED BY tools/gen_web_card_sources.py - DO NOT EDIT.
 *
 * card id -> the campaign stages that AWARD it by name.
 *
 * ⚠️ Only the HERO campaign names its cards, and it names FIVE. Everything else - the Five
 * Realms' 70 stages at three stars, its milestones, and all five champions of The Ascent -
 * pays a card drawn at RANDOM from the whole 171-card pool (`ProgressionStore.CardPool()`
 * takes every id, unfiltered), so it cannot say WHICH.
 *
 * ⛔ A card missing from this map is NOT unobtainable. It is obtainable from ~88 random
 * draws, which is how a player actually gets most of their collection. Rendering nothing
 * for those 166 cards - which is what every screen did - hid the answer to the question.
 *
 * ⚠️ IT DESCRIBES HOW A CARD CAN BE WON, NEVER HOW THIS PLAYER GOT THEIRS. The first
 * wording opened "Won from the reward pool..." and Alex read it as a claim about his own
 * copy - which he owned from the STARTER DECK, not from a campaign - and then reasonably
 * asked why the Tent did not list it. The Tent was right; the sentence was not. Anything
 * here must read as instructions, never as a receipt.
 */
export interface CardSource {
  readonly campaign: string;
  readonly stage: number;
  readonly title: string;
}

export const CARD_SOURCES: Readonly<Record<string, readonly CardSource[]>> = Object.freeze({
  "133": [{ campaign: "The Grove Awakens", stage: 1, title: "The First Sprout" }, { campaign: "The Grove Awakens", stage: 4, title: "Roots of Restoration" }],
  "163": [{ campaign: "The Grove Awakens", stage: 2, title: "Echoes of Vitality" }, { campaign: "The Grove Awakens", stage: 8, title: "Heart of Corruption" }],
  "164": [{ campaign: "The Grove Awakens", stage: 3, title: "The Elk's Trial" }, { campaign: "The Grove Awakens", stage: 7, title: "Stampede of Life" }],
  "165": [{ campaign: "The Grove Awakens", stage: 5, title: "The Ancient Awakens" }, { campaign: "The Grove Awakens", stage: 8, title: "Heart of Corruption" }],
  "166": [{ campaign: "The Grove Awakens", stage: 6, title: "Circle of Renewal" }],
});

/**
 * What to tell a player about every OTHER card.
 *
 * ⚠️ One owner for this sentence. Repeating it per screen is how it drifts from what `Pay`
 * actually does.
 */
export const RANDOM_CARD_SOURCE =
  "How to win it: any Five Realms stage cleared at three stars pays a card, its milestones "
  + "pay more, and every champion in The Ascent pays one - each drawn at random from the "
  + "whole set.";
